/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Outlook_No_Messages_TitleInputs */



/**
* | output |
* | --- |
* | "No messages" |
*
* @param {Spaces_Outlook_No_Messages_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_no_messages_title = /** @type {((inputs?: Spaces_Outlook_No_Messages_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_No_Messages_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Nachrichten")
	return /** @type {LocalizedString} */ ("No messages")
});